import { useEffect } from 'react'
import { useAuPayMonthlyRejectedReasonCode, useCohort, useHasSeenOpenPaymentSchedule, useIsBillingAgreementApprovalProcess } from '../../state'
import { Cohort, ErrorCode } from '@afterpaytouch/portal-api'
import { useTranslation } from '../../utils/convergence'

export const usePayMonthlyUnavailableText = (): string | undefined => {
  const { t } = useTranslation()
  const rejectedReasonCode = useAuPayMonthlyRejectedReasonCode()

  if (rejectedReasonCode === undefined) {
    return undefined
  }
  if (rejectedReasonCode === ErrorCode.AmountTooHigh || rejectedReasonCode === ErrorCode.OrderAmountTooHigh) {
    return t('summary:payMonthlyUnavailable.amountTooHigh')
  }
  return t('summary:payMonthlyUnavailable.default')
}

export const usePaymentScheduleInitialOpenStatus = (): boolean => {
  const cohort = useCohort()
  const { hasSeenOpenPaymentSchedule, saveToTags } = useHasSeenOpenPaymentSchedule()
  const isAPCohort = cohort === Cohort.APOnly

  const shouldShowOpenPaymentSchedule = !isAPCohort && !hasSeenOpenPaymentSchedule

  useEffect(() => {
    if (shouldShowOpenPaymentSchedule) {
      saveToTags()
    }
  }, [shouldShowOpenPaymentSchedule, saveToTags])

  return isAPCohort ? false : shouldShowOpenPaymentSchedule
}

export const useGetBillingApprovalSchedule = (): {
  installmentCount: number
  installmentPercentage: number
  installmentCadence: number
  installmentTimeline: number[]
} | null => {
  const isBillingAgreementApprovalProcess = useIsBillingAgreementApprovalProcess()

  if (!isBillingAgreementApprovalProcess) {
    return null
  }

  return {
    installmentCount: 4,
    installmentPercentage: 25,
    installmentCadence: 2,
    installmentTimeline: [0, 2, 4, 6],
  }
}
